<template>
    <div class="saas-cgu px-2 pt-2 pb-0">
        <!-- Loader -->
        <preloader :display="loading" />

        <!-- Header -->
        <header class="header px-1 flex-column mb-3">
            <SaasIcon
                icon="svgLogoSellsyText"
                :width="118"
                :height="28"
                class="logo secondary-blue"
            />
            <a
                v-if="areAccepted && !isEmbed"
                class="back-link grey-link semibold fs-3 flex-level"
                href="/"
                ><i class="el-icon-arrow-left semibold"></i>{{ $l10n.__('Retour') }}</a
            >
        </header>

        <!-- Content -->
        <div class="container m-auto">
            <h1 :class="{ 'mb-5': !areAccepted }">{{ termsTitle }}</h1>
            <h4 v-if="acceptanceDate && terms.acceptor" class="regular alert alert-info mb-5">
                {{
                    $filters.capitalize(
                        $l10n.__('acceptées le %(date)s par %(name)s (%(email)s)', {
                            date: acceptanceDateFormatted,
                            name: terms.acceptor.name,
                            email: terms.acceptor.email,
                        }),
                    )
                }}
            </h4>

            <embed
                v-if="terms.url"
                class="pdf-embed"
                :class="{ 'cgu-accepted': areAccepted }"
                :src="`${terms.url}`"
                type="application/pdf"
            />
        </div>

        <!-- Footer -->
        <fixed-footer v-if="!areAccepted">
            <div class="flex-level jc-center">
                <el-checkbox v-model="terms_checked">
                    <slot name="checkbox">
                        {{
                            $l10n.__(
                                'En cochant cette case, je reconnais avoir pris connaissance des %(terms_name)s de Sellsy et je les accepte.',
                                { terms_name: termsTitle },
                            )
                        }}
                    </slot>
                </el-checkbox>
                <CompassButton
                    :label="getContentButton"
                    :disabled="!terms_checked"
                    class="ml-5"
                    @click.prevent="terms_checked ? accept() : ''"
                />
            </div>
        </fixed-footer>
    </div>
</template>
<script>
// Mixins
import Preloader from 'vcomponents/utilities/Preloader.vue';
import SAMMixins from '../../mixins/subscription/SAMMixins';
import FixedFooter from 'vcomponents/utilities/FixedFooter.vue';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
        Preloader,
        FixedFooter,
    },
    mixins: [SAMMixins],
    props: {
        corporation: {
            type: String,
            required: true,
        },
        terms: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        isEmbed: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            terms_checked: false,
            loading: false,
        };
    },
    computed: {
        areAccepted() {
            return this.terms.status === 'accepted';
        },
        termsData() {
            return {
                saas_cgu: this.$l10n.__("Conditions Générales d'Utilisation"),
                saas: this.$l10n.__("Conditions Générales de Vente et d'Utilisation"),
                affil: this.$l10n.__('Conditions Générales de Parrainage'),
            };
        },
        termsTitle() {
            return this.termsData[this.type];
        },
        acceptanceDate() {
            return this.terms.created ? moment(this.terms.created) : null;
        },
        acceptanceDateFormatted() {
            return this.$filters.dateFormatter(
                this.acceptanceDate.unix(),
                'NORMAL_DATE_TIME_WITH_DAY',
                false,
            );
        },
        getContentButton() {
            return this.$filters.capitalize(this.$l10n.__('accepter'));
        },
    },

    methods: {
        accept() {
            this.loading = true;

            this.acceptTerms(this.type, this.terms.version)
                .then((response) => {
                    if (!response.success) {
                        throw new Error();
                    }
                    this.$emit('terms-accepted', false);
                })
                .catch((e) =>
                    Push.error(
                        this.$l10n.__(
                            'Problème lors de la validation des conditions générales, veuillez réessayer',
                        ),
                    ),
                )
                .finally(() => (this.loading = false));
        },
    },
};
</script>
<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.saas-cgu {
    // Header
    .header {
        .back-link {
            height: 20px;
        }
    }
    // Content
    .container {
        width: 820px;

        .cgu-accepted-message {
            .el-alert__title {
                font-size: $font-size;
                line-height: $font-size;
            }
        }
        .pdf-embed {
            width: 100%;
            height: calc(100vh - 190px);

            &.cgu-accepted {
                height: calc(100vh - 220px);
            }
        }
    }
}
</style>
